import * as React from 'react';

const Checked = ({ ...props }) => (
    <svg
        width="16"
        height="24"
        viewBox="0 0 16 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        {/* Tick is cut out of the box so it shows the button background in any theme */}
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14 6H2V18H14V6ZM5.354 11.646L7 13.293L10.646 9.646L11.354 10.354L7 14.707L4.646 12.354L5.354 11.646Z"
            fill="currentColor"
        />
    </svg>
);

export default Checked;
